export function isSameObject(val1,val2) {
	let object1String = JSON.stringify(val1);
	let object2String = JSON.stringify(val2);
	return (object1String === object2String);
}

export function getValueArray(arr){
	return (arr || []).concat();
}

export function getArrayIndex(arr,key,value){
	return arr.findIndex(row=>{
		return row[key] === value;
	})
}

export function getValueHash(hash){
	return JSON.parse(JSON.stringify(hash));
}

export function getArrayFromHash(hash){
	if(!hash){
		return []
	}
	return Object.keys(hash).map(function (key) {return hash[key]});
}

export function isObjectEquals(a, b){

	if(a === b){
		return true;
	}

	const aKeys = Object.keys(a).sort();
	const bKeys = Object.keys(b).sort();


	if(aKeys.toString() !== bKeys.toString()){
		return false;
	}

	const wrongIndex = aKeys.findIndex(function(value){
		return a[value] !== b[value];
	});

	// 合致しないvalueがなければ、trueを返す。
	return wrongIndex === -1;
}



// WEBPACK FOOTER //
// ./src/common/utils/array.js